
import React, {useEffect, useState} from 'react';

import {FaArrowRight, FaTimes} from 'react-icons/fa';



const Team = () => {
    useEffect(()=>{
document.title = "Office Sofas | Pinnacle Concepts Limited";
},[]);


  return (
    <section className='section-cover team-cover equip-cover' >
         <div className='content-container products-container'>
          
          <h2 className="home-h2 furniture-h2">Office Sofas</h2>
             {/* <p className='about-intro-p'>Exotic Furniture</p> */}
         
            <div className='services-container-new'>
              <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/23.jpg' class='item-image item-image-b'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/OF/OS/001</h3>
          </article>
                
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/53.jpg' class='item-image item-image-b'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/OF/OS/002</h3>
          </article>
          <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/120.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/OF/OS/003</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/121.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/OF/OS/004</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/122.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/OF/OS/005</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/123.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/OF/OS/006</h3>
          
          </article>
           <article className='single-service-new'>
              <div className='tools-slides-cover'>
                {/* <Tool3></Tool3> */}
                <img src='./images/22.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/OF/OS/007</h3>        
          </article>
           
        
      </div>
         </div>
    </section>
  )
}

export default Team